import angular from 'angular';

angular
  .module('cxRegistrations')
  .controller('NewCategoryDialogCtrl', [
    '$element',
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    'close',
    '$http',
    'appUrls',
    'enumCacheSvc',
    'checkSecurity',
    'checkFeature',
    '$filter',
    newCategoryDialogCtrl,
  ]);

function newCategoryDialogCtrl(
  $element,
  dataCache,
  resourceFactorySvc,
  flySvc,
  close,
  $http,
  appUrls,
  enumCacheSvc,
  checkSecurity,
  checkFeature,
  $filter,
) {
  var vm = this;
  vm.showValidation = false;
  vm.resourceTypes = [];
  vm.translation = {};
  vm.category = {
    type: null,
    name: '',
    code: null,
    price: null,
    vatPercentage: dataCache.getDefaultCompany().resourceVATRate || 0.21,
    vatType: 0,
    isBillable: true,
    inForfait: false,
    ledgerAccount: dataCache.getDefaultCompany().resourceLedgerAccount,
    enabledOnAllAssignments: true,
  };
  vm.showAssignments = dataCache.getArray('assignmentsEnabled');
  enumCacheSvc.get('resourceType').then(data => {
    const canCreateResource = checkSecurity('Pricelist:c');
    const canCreateAbsence = checkSecurity('AbsenceAndCounters:c');
    vm.resourceTypes = data
      .filter(x => {
        if (x.key === 3 || x.key === 4) return canCreateAbsence;
        return canCreateResource;
      })
      .map(x => ({ ...x, label: $filter('translateList')(x.key, 'resourceType', x.value) }));
  });
  vm.resourceTypeChanged = function() {
    vm.category.inForfait = vm.category.type === 0;

    if (vm.category.type === 3 || vm.category.type === 4 || vm.category.type === 5) {
      vm.category.price = 0;
    }
  };

  var regResource = resourceFactorySvc.get('resource');

  vm.save = function() {
    if (vm.category.type === 3 || vm.category.type === 4 || vm.category.type === 5) {
      //Absence and training
      vm.category.inForfait = false;
      vm.category.isBillable = false;
      vm.category.ledgerAccount = null;
      vm.category.price = 0;
    }
    vm.saving = true;
    regResource.saveCategory(
      vm.category,
      function(result) {
        if (result.id && vm.translation && vm.translation.save) {
          vm.translation.save(result.id).then(function(translationResult) {
            // save resource that was created by category to translations as well
            if (result.resource && translationResult && translationResult.length) {
              var key = `resource_${result.resource.id}`;
              var changes = translationResult.map(x => ({ ...x, key: key }));
              $http.put(appUrls.api + '/api/translation/lists/0', changes);
            }

            $element.modal('hide');
            close(result, 500);
          });
        } else {
          $element.modal('hide');
          close(result, 500);
        }
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.updateName = function(value) {
    vm.category.name = value;
  };
  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
